import { render, staticRenderFns } from "./indexLimit.vue?vue&type=template&id=5f12374c&scoped=true&"
import script from "./indexLimit.vue?vue&type=script&lang=js&"
export * from "./indexLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f12374c",
  null
  
)

export default component.exports